/* eslint-env browser */

(function () {
    const mediaQuery = window.matchMedia('(max-width: 767px)');
    const nav = document.querySelector('.gd-nav .nav');

    if (!nav) {
        return;
    }

    function updateNavItemTransitionDelay() {
        nav.querySelectorAll('li').forEach(function (item, index) {
            item.style.transitionDelay = mediaQuery.matches ? (0.03 * (index + 1)) + 's' : '';
        });
    }

    updateNavItemTransitionDelay();

    if (typeof mediaQuery.addEventListener === 'function') {
        mediaQuery.addEventListener('change', updateNavItemTransitionDelay);
    } else if (typeof mediaQuery.addListener === 'function') {
        mediaQuery.addListener(updateNavItemTransitionDelay);
    }
})();
